import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Hero from './components/Hero';
import CategoryNav from './components/CategoryNav';
import HotMatches from './components/HotMatches';
import LatestNews from './components/LatestNews';
import Features from './components/Features';
import Stats from './components/Stats';
import FAQ from './components/FAQ';
import CTA from './components/CTA';

const homepageJsonLd = {
  "@context": "https://schema.org",
  "@type": "WebPage",
  "name": "kaiyun体育 - 官方体育平台入口",
  "description": "专业的在线体育平台，提供全球体育赛事资讯与直播服务",
  "url": "https://yunmatch.github.io/",
  "isPartOf": {
    "@type": "WebSite",
    "name": "kaiyun体育",
    "url": "https://yunmatch.github.io/"
  }
};

export default function Home() {
  return (
    <>
      <title>kaiyun体育 - 官方体育平台入口 | 全球体育赛事资讯与直播</title>
      <meta name="description" content="kaiyun体育是专业的在线体育平台，提供体育赛事资讯、赛事直播、体育竞技等全方位服务。汇聚全球顶级赛事，为广大体育爱好者提供极致体验，立即访问kaiyun体育官方入口，开启精彩体育之旅。" />
      <meta name="keywords" content="kaiyun体育,kaiyun体育官网,kaiyun体育平台,kaiyun体育入口,kaiyun体育赛事,kaiyun体育直播,kaiyun体育注册" />
      <link rel="canonical" href="https://yunmatch.github.io/" />
      <meta property="og:title" content="kaiyun体育 - 官方体育平台入口 | 全球体育赛事资讯与直播" />
      <meta property="og:description" content="kaiyun体育是专业的在线体育平台，提供体育赛事资讯、赛事直播、体育竞技等全方位服务。" />
      <meta property="og:type" content="website" />
      <meta property="og:url" content="https://yunmatch.github.io/" />
      <script type="application/ld+json">
        {JSON.stringify(homepageJsonLd)}
      </script>

      <Navbar />
      <main>
        <Hero />
        <CategoryNav />
        <HotMatches />
        <LatestNews />
        <Features />
        <Stats />
        <FAQ />
        <CTA />
      </main>
      <Footer />
    </>
  );
}